import { getGlobalData } from "../utils/api"
import Seo from "../components/elements/seo"
import Head from "next/head"
import Link from "next/link"
import Image from "next/image"

import { useInView } from "react-intersection-observer";
import { useState } from "react";

import HorizontalScroll from "../components/elements/carousel-slider/horizontal-scroll";

const LandingPage = ({ global, metadata }) => {
  const [ref1, inView1] = useInView({ threshold: 0.2 });
  const [ref2, inView2] = useInView({ threshold: 0.2 });
  const [ref3, inView3] = useInView({ threshold: 0.2 });
  const [ref4, inView4] = useInView({ threshold: 0.2 });
  //const [ref5, inView5 ] = useInView({ threshold: 0.2 });
  const [ref6, inView6] = useInView({ threshold: 0.2 });
  const [email, setEmail] = useState("");
  const [message, setMessage] = useState("");

  const handleSubscribe = async () => {
    if (!email) {
      setMessage("Please enter a valid email address.");
      return;
    }

    try {
      const response = await fetch("/api/subscribe-user", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ email }),
      });

      if (response.ok) {
        setMessage("Success! You've been subscribed.");
        setEmail(""); // Clear the email field
      } else {
        const errorData = await response.json();
        setMessage(errorData.error || "Something went wrong. Please try again.");
      }
    } catch (error) {
      //console.error("Error subscribing:", error);
      setMessage("There was an error subscribing. Please try again.");
    }
  };

  const metadataWithDefaults = {
    ...global.metadata,
    ...metadata,
  }
  const canonicalHref = metadataWithDefaults.canonicalURL

  return (
    <>
      {canonicalHref ? <Head><link rel="canonical" href={canonicalHref} key="canonical" /></Head> : <></>}
      <Seo metadata={metadataWithDefaults} />
      <div className="bg-gray-50 text-gray-800 box-border mt-32 inline-block">

        {/* Hero Section */}
        <section className="min-h-screen max-h-screen bg-gradient-to-r from-yellow-200 to-yellow-500 flex flex-col lg:flex-row items-center justify-center lg:justify-between px-6 lg:px-12 pb-28">
          {/* Text Content */}
          <div className="text-center">
            <h1 className="text-5xl font-bold text-gray-800 m-4">
              Say Goodbye to Ordinary Crispy Treats
            </h1>
            {/* Responsive Image */}
            <div className="mt-8 lg:mt-0 lg:ml-12">
              <Image
                height={900}
                width={1200}
                src="https://storage.googleapis.com/application_content/PXL_20240612_010613470_RAW_01_COVER_1894b61899/PXL_20240612_010613470_RAW_01_COVER_1894b61899.jpg"
                alt="Browned & Toasted Treats"
                className="rounded-lg shadow-lg h-auto object-cover sm:w-96"
                loading="lazy"
              />
            </div>
            <div>
            <p className="text-2xl text-gray-700 mb-6">
              And hello to the life-changing experience of deeply browned butter and rich toasted sugar marshmallow.
            </p>
            <Link
              href="https://brownedandtoasted.com/store"
              className="px-6 py-3 text-3xl bg-crimson text-white text-lg rounded-lg hover:bg-sunrise transition"
            >
              Take Me To The Treats
            </Link>
            </div>
          </div>

        </section>
        {/* Section 1: Why It's Better */}
        <section
          ref={ref1}
          className={`pt-12 min-h-screen flex items-center justify-center transition duration-500 ${inView1 ? "opacity-100 translate-y-0" : "opacity-0 translate-y-12"
            }`}
        >
          <div className="max-w-4xl text-center px-6">
            <h2 className="text-4xl font-bold mb-4">Meet your NEW Favorite Treat</h2>
            <p className="text-lg mb-6">
              Browned & Toasted Marshmallow Crispy Bars elevate everything you love
              about the classic crispy treat and make it better.
              <br />Handcrafted with browned
              butter from grass fed cows and marshmallow made with toasted sugar, every bite is rich, buttery, nutty, a touch salty, and perfectly
              balanced-- <b>without the shopping, browning, melting, mixing, waiting and guilt </b> from eating a whole tray.
            </p>
            <div className="mt-8 lg:mt-0 max-w-lg">
              <Image
                height={900}
                width={1200}
                src="https://storage.googleapis.com/application_content/close_up_in_jar_96dd670657/close_up_in_jar_96dd670657.jpg"
                alt="A simple glass treat jar filled to the brim with colorful marshmallow crispy bars."
                className="rounded-lg shadow-lg w-full h-auto object-cover"
                loading="lazy"
              />
            </div>
          </div>
         
        </section>
        {/* <div className='relative w-full min-h-screen'>
         <HorizontalScroll ref={ref5} className={`relative min-h-screen flex items-center justify-center transition duration-500 ${inView5 ? "opacity-100 translate-y-0" : "opacity-0 translate-y-12"}`}>
            <div key="sampleCard-1" className="relative h-[300px] w-[500px] bg-crimson mr-[75px] shrink-0" />
            <div key="sampleCard-2" className="relative h-[300px] w-[500px] bg-chocolate mr-[75px] shrink-0" />
            <div key="sampleCard-3" className="relative h-[300px] w-[500px] bg-sunrise mr-[75px] shrink-0" />
            <div key="sampleCard-4" className="relative h-[300px] w-[500px] bg-sunset mr-[75px] shrink-0" />
            <div key="sampleCard-5" className="relative h-[300px] w-[500px] bg-black mr-[75px] shrink-0" />
          {/* <div className="py-[128px] text-center px-[16px]" /> 
        </HorizontalScroll>
        </div> */}

        {/* Section 2: Why It's Better */}
        <section
          ref={ref2}
          className={`min-h-screen flex items-center justify-center transition duration-500 ${inView2 ? "opacity-100 translate-y-0" : "opacity-0 translate-y-12"
            }`}
        >
          <div className="max-w-4xl text-center px-6">
            <h2 className="text-4xl font-bold mb-4">Extraordinary Treats Are Made With Extraordinary Marshmallow</h2>
            <p className="text-lg mb-6">
              We make our life changing marshmallow fresh for every batch of crispy treats. Why? Because it tastes better. Our marshmallow is made with toasted sugar, which gives it a rich, nutty flavor and a beautiful golden color. We also use browned butter from grass-fed cows, which adds a depth of flavor that you won&#39;t find in any other crispy treat. The result is a treat that is truly extraordinary. 
            </p>
          </div>

        </section>

        {/* Section 3: Flavor Highlights */}
        <section
          ref={ref3}
          id="treats"
          className={`min-h-screen bg-white flex flex-col items-center justify-center transition duration-500 ${inView3 ? "opacity-100 translate-y-0" : "opacity-0 translate-y-12"
            }`}
        >
          <div className="text-center px-6">
            <h2 className="text-4xl font-bold px-6">
              Try One Of Our Signature Flavors
            </h2>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mx-6">
            <Link href="https://www.brownedandtoasted.com/store/Original-Marshmallow-Crispy-Treat-p640314516">
              <div className="p-6 bg-gray-100 rounded-lg shadow-md">
                <h3 className="text-2xl font-bold mb-4">The Browned Butter Original</h3>
                <p className="text-gray-700">
                  The classic perfected. Rich Goldmallow and just enough toasted crispy cereal, come together in a texture and flavor explosion.
                </p>
                <div className="justify-end w-full flex leading-8 text-crimson">Learn More..</div>
              </div>
            </Link>
            <Link href="https://www.brownedandtoasted.com/store/Lemon-Blueberry-Marshmallow-Crispy-Treat-p640645443">
              <div className="p-6 bg-gray-100 rounded-lg shadow-md">
                <h3 className="text-2xl font-bold mb-4">Lemon Blueberry</h3>
                <p className="text-gray-700">
                  A zesty twist with bright and tart lemon marshmallow and real blueberry
                  pieces on a bed of blueberry marshmallow. It’s sunshine in every bite.
                </p>
              <div className="justify-end w-full flex leading-8 text-crimson">Learn More..</div>`
              </div>
            </Link>
            <Link href="https://www.brownedandtoasted.com/store/Cookies-and-Cream-Marshmallow-Crispy-Treat-p640672289">
              <div className="p-6 bg-gray-100 rounded-lg shadow-md">
                <h3 className="text-2xl font-bold mb-4">Cookies & Cream</h3>
                <p className="text-gray-700">
                  Crushed cocoa cookies and vanilla cream and buttery toasty marshmallow collide in a
                  perfectly balanced, indulgent bar.
                </p>
                <div className="justify-end w-full flex leading-8 text-crimson">Learn More..</div>
              </div>
            </Link>
            <Link href="https://www.brownedandtoasted.com/store/Marshmallow-Crispy-Our-Favorites-4-Pack-p719248140">
              <div className="p-6 bg-gray-100 rounded-lg shadow-md">
                <h3 className="text-2xl font-bold mb-4">Start Your Journey: Favorites Four-Pack</h3>
                <p className="text-gray-700">
                  Three Varieties: 2 x The Original, Lemon Blueberry, Cookies & Cream for a taste of our intense flavors.
                </p>
                <div className="justify-end w-full flex leading-8 text-crimson">Learn More..</div>
              </div>
            </Link>
          </div>
        </section>

        {/* Section 4: Call to Action */}
        <section
          ref={ref4}
          className={`min-h-screen flex flex-col items-center justify-center bg-blue-50 transition duration-500 ${inView4 ? "opacity-100 translate-y-0" : "opacity-0 translate-y-12"}`}
        >
          <div className="mt-8 lg:mt-0 lg:ml-12 max-w-lg">
            <Image
              height={1542}
              width={2048}
              src="https://storage.googleapis.com/application_content/PXL_20250112_214147082_PORTRAIT_724a049444/PXL_20250112_214147082_PORTRAIT_724a049444.jpg"
              alt="Browned & Toasted Treats"
              className="rounded-lg shadow-lg w-full h-auto object-cover"
              loading="lazy"
            />
          </div>

          <div className="text-center px-6 max-h-screen">
            <h2 className="text-4xl font-bold text-blue-600 mb-4">
              
            </h2>
            <p className="text-lg text-chocolate mb-6">
              Are you ready to experience the best crispy treat of your life? Order now and get ready to be amazed.
            </p>
            <div className="flex flex-col md:flex-row items-center justify-center space-y-4 md:space-y-0 md:space-x-4">
              {/* <input
                type="email"
                autoComplete="email"
                id="email"
                placeholder="Enter your email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                className="px-4 py-2 rounded-lg border border-gray-300 focus:outline-none focus:ring-2 focus:ring-blue-500"
              /> */}
              { message && <div className="text-center text-crimson text-bold">{message}</div> }
              {/* <button
                onClick={handleSubscribe}
                className="px-6 py-3 bg-crimson text-white rounded-lg hover:bg-sunrise transition"
              >
                Order Now!
              </button> */}
              <Link href="https://www.brownedandtoasted.com/store">
                <button  className="text-4xl px-2 py-2 bg-crimson text-white rounded-lg hover:bg-sunrise transition">
                  Order Now!
                </button>
              </Link>
            </div>
          </div>
        </section>
      </div>
    </>
  )
}

export async function getStaticProps(context) {
  const { params, locale, locales, defaultLocale } = context
  const globalData = await getGlobalData(locale)

  const pageContext = {
    locale,
    locales,
    defaultLocale,
    isLandingPage: true,
    //      localizations,
  }

  let metadata = {
    metaTitle: `Browned & Toasted | Tired of Ordinary Snacks?`,
    metaDescription: `Meet your new favorite treat. Browned & Toasted Marshmallow Crispy Bars elevate everything you love about the classic crispy treat and make it better.`,
    canonicalURL: `https://brownedandtoasted.com/landing-page`,
  }

  let preview = context.preview || false
  //  const localizedPaths = getLocalizedPaths(pageContext)

  // fetch the available bars
  try {
    return (
      {
        props: {
          globalData,
          metadata,
          pageContext: pageContext,
          locale,
          preview: preview,
        },
      }
    )
  } catch (error) {
    return {
      revalidate: 60,
      props: {
        locale,
        error: 500
      }
    }
  }
}


export default LandingPage